import React from "react";
import { Box, CircularProgress } from "@mui/material";

export default function RouteFallback() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 240,
        width: "100%",
      }}
    >
      <CircularProgress size={36} />
    </Box>
  );
}
